<template>
  <div class="content--sinoreg">
    <div class="LivroCaixa">
      <div class="LivroCaixa_header">
        Livro Caixa
      </div>
      <div class="LivroCaixa_body">
        <b-tabs class="Resumo-border"
                align="left"
                active-nav-item-class="Resumo--tab-active">
          <b-tab :active="tabIndex === 0"
                 @click="tabIndex = 0 "
                 @keydown.tab.prevent="tabIndex = 0">
            <template v-slot:title>
              Lançamentos de Despesas e Receitas
            </template>
            <Lancamentos />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  // Components
  import Lancamentos from '@/components/LivroCaixa/Lancamentos'
  import Impressao from '@/components/LivroCaixa/ImpressaoLivroCaixa'

  // Services
  import LivroCaixaService from '../../services/LivroCaixaService'

  export default {
    name: 'LivroCaixa',
    components: {
      Lancamentos,
      Impressao
    },
    data () {
      return {
        tabIndex: 0
      }
    },
    async created () {
      await this.ajusteLacamentoLivroCaixa()
    },
    methods: {
      async ajusteLacamentoLivroCaixa () {
        // Cria alançamentos à partir de 18/02/2023 durante período de bug
        await LivroCaixaService.ajusteLacamentoLivroCaixa()
      }
    }
  }
</script>

<style lang="scss">
  .LivroCaixa {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
    }
  }
</style>
